import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TextField, MenuItem } from "@material-ui/core";
import _ from "lodash";
import queryString from "query-string";
import cloneDeep from "lodash/cloneDeep";
import HorizontalScrollView from "../../../components/component_horizontal_scroll_view";
import { SchoolDashboardStats } from "./school_dashboard_stats";
import { SchoolDashboardStudents } from "./school_dashboard_students";
import { SchoolDashboardTeam } from "./school_dashboard_team";
import SchoolDashboardAddStudent from "./school_dashboard_add_student";
import { MyAccountPostedOpp } from "../dashboard_opportunity/my_account_posted_opportunities";
import classnames from "classnames";
import "./school_dashboard_index.less";
import {
  modle_user,
  ModelUser,
  LoginWithTokenAction,
} from "../../../models/model_user";
import { mapProp, doAction, doFunction } from "module-reaction";
import { chatClient, initChatClient } from "../../../utils/chatHelper";
import { router_school_payment_with_id, SchoolRole } from "../../../utils/enum";
import { getRoleName } from "../../../components/component_employee_gridview";
import {
  freshDashboardAction,
  model_dashboad_index,
  ModleDashBoardIndex,
} from "../../../models/model_dashboard_index";
import { Button, Spin } from "antd";
import iconNote from '../../../assets/images/ic_big_note.svg'

interface SchoolDashboardProps extends ModelUser, RouteComponentProps, ModleDashBoardIndex { }

@mapProp(modle_user)
@mapProp(model_dashboad_index)
export class SchoolDashboardIndex extends React.Component<
SchoolDashboardProps,
{}
> {
  get curSchool() {
    return this.props.curCanvas;
  }

  get dashboardRouters() {
    const curCanvas: any = this.curSchool;
    return [
      {
        name: "My Team",
        component: () => (
          <SchoolDashboardTeam
            school={curCanvas}
            changeTab={this.changeTab}
            history={this.props.history}
            curUser={this.props.curUser}
          />
        ),
        hidden:
          false,
        hiddenByCanvas:
          false,
      },
      {
        name: "My Students",
        component: () => (
          <SchoolDashboardStudents
            school={curCanvas}
            changeTab={this.changeTab}
            history={this.props.history}
            curUser={this.props.curUser}
          />
        ),
      },

      {
        name: "Add Students",
        component: () => (
          <SchoolDashboardAddStudent
            school={curCanvas}
            changeTab={this.changeTab}
          />
        ),
        hidden: true,
      },
      {
        // name: curCanvas && curCanvas.memberRole && curCanvas.memberRole === SchoolRole.ADMIN ? "Available Opportunities" : "Posted Opportunities",
        name: "Posted Opportunities",
        component: () => (
          <MyAccountPostedOpp
            canvasInfo={curCanvas}
            history={this.props.history}
          ></MyAccountPostedOpp>
        ),
        hidden:
          false,
        hiddenByCanvas:
          false,
      },
      {
        name: "Stats",
        component: () => (
          <SchoolDashboardStats
            school={curCanvas}
            history={this.props.history}
          />
        ),
      },
    ];
  }

  state = {
    curTab: _.last(this.dashboardRouters),
  };

  changeTab = (name: string) => {
    const tab = _.find(this.dashboardRouters, { name });
    if (!tab) {
      return;
    }
    this.setState({ curTab: tab });
    this.syncTabQueryParam(name);
  };

  tabType: any = {
    posted_opportunity: "Posted Opportunities",
    team: "My Team",
    students: "My Students",
    stats: "Stats",
    add_students: "Add Students",
  };

  private syncTabQueryParam = (tabName: string) => {
    const tabType = _.findKey(this.tabType, (name) => name === tabName);
    if (!tabType) {
      return;
    }

    const searchObj: any = queryString.parse(this.props.location.search);
    if (searchObj.tabType === tabType) {
      return;
    }

    const nextSearch = queryString.stringify({
      ...searchObj,
      tabType,
    });
    this.props.history.replace({
      ...this.props.location,
      search: nextSearch ? `?${nextSearch}` : "",
    });
  };

  componentDidMount() {
    if (!this.props.curUser || !this.props.curUser.id) {
      doAction(LoginWithTokenAction);
    }
    doFunction(async () => {
      if (!chatClient) {
        await initChatClient(this.props.curUser);
      }
    });
    if (!this.props.curCanvas) {
      doAction(freshDashboardAction);
    }
    this.initCurTab();
  }

  componentDidUpdate(prevProps: SchoolDashboardProps) {
    if (prevProps.curCanvas?.id !== this.props.curCanvas?.id) {
      this.initCurTab();
    }
    const searchObj: any = queryString.parse(this.props.location.search);
    const prevSearchObj: any = queryString.parse(prevProps.location.search);
    if (searchObj.tabType !== prevSearchObj.tabType) {
      this.initCurTab();
    }
  }

  private initCurTab = () => {
    const searchObj: any = queryString.parse(window.location.search);
    const dashboardRouters = this.dashboardRouters;
    if (searchObj && searchObj.tabType && this.tabType[searchObj.tabType]) {
      const router = _.find(dashboardRouters, {
        name: this.tabType[searchObj.tabType],
      });
      router && this.setState({ curTab: router });
      // } else if (!dashboardRouters.some(_ => !_.hidden && _.name === this.state.curTab?.name)) {
    } else if (
      !dashboardRouters.some(
        (_) => !_.hiddenByCanvas && _.name === this.state.curTab?.name
      )
    ) {
      this.setState({ curTab: _.last(dashboardRouters) });
    }
  };
  el: any = null;

  schoolPayTip = () => {
    return <div className="school-pay-tip">
      <div className="tip-content">
        <img src={iconNote} alt="note" />
        <div className="tip-title">Subscribe to School plan to use the dashboard</div>
        <div className="tip-des">This canvas profile has not subscribed to a paid plan. Please process your payment to see your dashboard.</div>
        <Button 
        className="btn-primary btn-pay"
        onClick={e => window.location.href = `${process.env.REACT_APP_NEXT_URL}/subscribe/school/${this.curSchool.id}`}
        >Subscribe</Button>
      </div>
    </div>
  }

  render() {
    const { curCanvas, canvasList } = this.props;
    if (!curCanvas) {
      return (
        <div className="school-dashboard-wrap">
          <Spin />
        </div>
      );
    }

    const activeTab =
      this.dashboardRouters.find((t) => t.name === this.state.curTab?.name) ||
      _.last(this.dashboardRouters);
    const comp = activeTab?.component();
    let schoolSelect = 0;
    if (curCanvas) {
      schoolSelect = canvasList.findIndex((s: any) => s.id === curCanvas.id);
    }
    const tabs = cloneDeep(this.dashboardRouters)
      .reverse()
      .map((item: any, index: number) =>
        item.hidden ? null : (
          <span
            className={classnames("tab-btn tab-item", {
              active: this.state.curTab && item.name === this.state.curTab.name,
            })}
            key={index}
            onClick={() => this.changeTab(item.name)}
          >
            {item.name}
          </span>
        )
      ).filter(Boolean);
    const canViewDashboard =
      this.props.curCanvasPaid || Boolean(this.props.curUser?.adminBehalf);
    const showLockedBadge =
      Boolean(this.props.curUser?.adminBehalf) && !this.props.curCanvasPaid;

    return (
      <div className="school-dashboard-wrap">
        <div className="school-dashboard-tab-wrap">
          <div className="tab-list">
            <HorizontalScrollView className="scroll" hideNavi={tabs.length === 0}>
              {tabs}
            </HorizontalScrollView>
          </div>
          <TextField
            label="Dashboard"
            variant="filled"
            select
            className="material-input input"
            value={"" + schoolSelect || ""}
            onChange={(e) => {
              const curCanvas = this.props.canvasList[e.target.value];
              doAction(freshDashboardAction, curCanvas);
            }}
          >
            {this.props.canvasList.map((item: any, index: number) => (
              <MenuItem key={index} value={"" + index}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
          {this.curSchool?.memberRole && (
            <div className="member-role">
              View as {getRoleName(this.curSchool.memberRole)}
            </div>
          )}
        </div>

        {showLockedBadge && (
          <div className="school-dashboard-locked-badge">
            Dashboard locked for this school — admin preview
          </div>
        )}
        {canViewDashboard ? comp : this.schoolPayTip()}
      </div>
    );
  }
}
